import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import { StatusIcon } from "components/common";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import { toSalesforceInputCreateRequest } from "./common/formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
    whitespace: pre-wrap;
    overflow-wrap: break-word;
  `
);
const containerStyle = {
  whiteSpace: "pre-wrap",
  overflowWrap: "break-word",
  width: "1500px"
};
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      line-height: 2;
      padding: 0 5px;

      &:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong::after {
      content: ':';
      margin-right: 5px;
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit }) => {
  var _a;
  const [formError, setFormError] = useState(null);
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.salesforceThrottleEnabled) == null ? void 0 : _a.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    () => onSubmit(),
    "POST",
    toSalesforceInputCreateRequest(formData),
    urlWithEventHubParams
  );
  useEffect(() => {
    setSaveInput(null);
    if (saveInput.error) {
      setFormError({
        full_message: saveInput.error,
        nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to save your Input, please try again in a few moments.")
      });
    }
  }, [saveInput.error, setSaveInput]);
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.Salesforce.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Save and Start Input",
      loading: saveInput.loading,
      error: formError,
      description: "Check out everything below to make sure it's correct, then click the button below to complete your Salesforce setup!"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, "Input Configuration"), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Name"), /* @__PURE__ */ React.createElement("span", null, formData.salesforceName.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Salesforce Base Url"), /* @__PURE__ */ React.createElement("span", null, formData.salesforceBaseUrl.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Consumer Key"), /* @__PURE__ */ React.createElement("span", null, formData.salesforceClientId.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Polling Interval"), /* @__PURE__ */ React.createElement("span", null, formData.pollingInterval.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("div", { style: containerStyle }, /* @__PURE__ */ React.createElement("strong", null, "Subscribed To"), formData.logTypes.value.replaceAll(",", ", "))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Enable Throttling"), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Access Token Expires In (Hours)"), /* @__PURE__ */ React.createElement("span", null, formData.accessTokenExpiresIn.value))))
  );
};
export default StepReview;
